import { Product3dModel, Product3dProvider } from '@app-types/product-3d';

const models: Record<string, Product3dModel> = {
    appleiPhone17: {
        provider: Product3dProvider.APPLE_360_SPIN,
        name: 'iPhone 17',
        scriptUrl: '/statics/ecommerce/apple-360-spin/v1/scripts/apple360spin.js',
        assetsPath: '/statics/ecommerce/apple-360-spin/v1/iphone-17/assets/',
        colors: [
            { name: 'Noir', hex: '#353839', filename: 'iphone_17_sim_black.gltf' },
            { name: 'Blanc', hex: '#f5f5f5', filename: 'iphone_17_sim_white.gltf' },
            { name: 'Lavande', hex: '#dfceea', filename: 'iphone_17_sim_lavender.gltf' },
            { name: 'Bleu', hex: '#96aed1', filename: 'iphone_17_sim_mist-blue.gltf' },
            { name: 'Sauge', hex: '#a9b689', filename: 'iphone_17_sim_sage.gltf' },
        ],
    },
};

class Product3dRepository {
    public getByProductId(productId: string): Product3dModel | undefined {
        return models[productId];
    }
}

export const product3dRepository = new Product3dRepository();
